<!-- Main Page Start -->
<section class="completeProfile" *ngIf="showDiv">
    <div class="container">
      <div class="topHeader">
        <h2 class="mainTitle" > Complete your company profile </h2>
      </div>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="profileInfo mb-5">
            <div class="profile-upload ">
                <div class="proEdit">
                     <input type="file" accept=".png, .jpg, .jpeg" #myInput (change)="upload($event)" title="Edit">
                    <label id="imageUpload" title="Edit"><i class="ic_profile_edit"><img src="assets/images/ic_profile_edit.svg"></i></label>
                </div>
                <div class="avatar-preview">
                    <div id="imagePreview">
                        <img [src]="imageUpload != null || imageUpload == '' ? globalUrl + imageUpload : '../../../assets/images/companyprofile.png'" alt="profile">
                    </div>
                </div>
            </div>
            <div class="text-danger" *ngIf="showErrorImage">
                *Please upload company logo.
            </div> 
            <div class="profileName">
                <p class="para3">JPG or PNG. Image must be 500 x 500 pixels or less. </p>
            </div>
        </div>
        <div class="personal-info">
             <h5 class="subTitle"> Company Info </h5>
             <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="form-group">
                      <label>Company name <span class="orange">*</span></label>
                      <input type="text" class="form-control"  placeholder="Enter" formControlName="companyName" maxlength="100"/>
                      <div class="text-danger" *ngIf="form.controls['companyName'].hasError('required') && showError">
                          *Please enter company name.
                      </div> 
                  </div>
                  <div class="form-group">
                      <label> Industry  <span class="orange">*</span></label>
                  
                      <input type="text" class="form-control"  placeholder="Financial services" formControlName="industry"  maxlength="30"/>
                      <div class="text-danger" *ngIf="form.controls['industry'].hasError('required') && showError">
                          *Please enter industry.
                      </div>
                  </div>
                  <div class="form-group  mb-0">
                      <label> Company Size</label>
                  
                      <input type="text" class="form-control"  placeholder="250" formControlName="companySize"  (keypress)="preventNumbers($event)" maxlength="10">
                      <div class="text-danger" *ngIf="form.controls['companySize'].hasError('required') && showError">
                          *Please enter company size.
                      </div>
                  </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12" >
                  <div class="form-group mb-0">
                      <label> Company’s description <span class="orange">*</span></label>
                      <textarea type="text" class="form-control textArea" placeholder="Please enter description" formControlName="description" maxlength="250"></textarea>
                      <p class="para5">{{form?.value?.description?.length}}/250</p>
                      <div class="text-danger" *ngIf="form.controls['description'].hasError('required') && showError">
                          *Please Enter description.
                      </div>
                      <div class="text-danger" *ngIf="form.controls['description'].hasError('maxlength') && showError">
                          *Minimum length of 250 characters.
                      </div>
                  </div>
              </div>
            </div>
            <div class="row pt-0 mt-0">
                <div class="col-sm-12 col-lg-6 col-md-6">
                    <div class="addressWrap">
                        <h5 class="subTitle"> Address info </h5>
                        <div class="detectLocation"> Detect my current location  <a href="javascript:void(0);" class="allowBtn" (click)="openModal(addMore)">  Allow </a></div>
                    </div>
                    <div class="enterManually"><span> Or, enter manually </span></div>
                </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                  <div class="form-group">
                      <label>Address <span class="orange">*</span> </label>
                      <textarea type="text" class="form-control"  placeholder=" Cr 92 No. 34E-112, Medellín " formControlName="address"
                        ngx-google-places-autocomplete (onAddressChange)="onAddressChange($event)"></textarea>
                      <div class="text-danger" *ngIf="form.controls['address'].hasError('required') && showError">
                          *Please enter address.
                      </div>
                  </div>
              </div>
              <div class="col-md-6 col-lg-6 "> 
                      <div class="form-group">
                          <label> Zipcode<span class="orange">*</span></label>
                          <input type="text" class="form-control" placeholder="Enter" formControlName="zipCode" (keypress)="preventNumbers($event)" maxlength="6">
                          <div class="text-danger" *ngIf="form.controls['zipCode'].hasError('required') && showError">
                              *Please enter zip code.
                          </div>
                        
                      </div>
              </div>
              <div class="col-md-6 col-lg-6 ">
                <div class="form-group">
                    <label> City <span class="orange">*</span> </label>
                    <input type="text" class="form-control"  placeholder="Enter " formControlName="city">
                    <div class="text-danger" *ngIf="form.controls['city'].hasError('required') && showError">
                        *Please select the city.
                    </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-lg-6">
                  <div class="form-group">
                      <label> State  <span class="orange">*</span></label>
                      <select class="form-control" formControlName="state">
                          <option selected="selected" disabled  hidden> Please select</option>
                          <option *ngFor="let states of allStates;let i=index;" [value]="states.name"> {{states.name}}</option>
                      </select>
                      <!-- <input type="text" class="form-control"  placeholder="Enter " formControlName="state"> -->
                          <div class="text-danger" *ngIf="form.controls['state'].hasError('required') && showError">
                              *Please select the state.
                          </div>
                  </div>
              </div>
              <div class="col-md-6 col-sm-12 col-lg-6">
                  <div class="form-group">
                      <label> Country <span class="orange">*</span></label>
                      <select class="form-control" formControlName="location">
                          <option disabled selected> Please select</option>
                          <option value="USA"> USA</option>
                      </select>
                      <div class="text-danger" *ngIf="form.controls['location'].hasError('required') && showError">
                          *Please select the country.
                      </div>
                  </div>
              </div>
            </div>
            <div class="row">
                    <div class="col-sm-12">
                      <h5 class="subTitle"> Company info</h5>
                  </div>
                <div class="col-md-6 col-sm-12 col-lg-6">
                    <div class="form-group">
                        <label> Company Email</label>
                        <input type="text" class="form-control"  placeholder="Enter " formControlName="companyEmail">
                        <div class="text-danger" *ngIf="form.controls['companyEmail'].hasError('required') && showError">
                            *Please enter company email.
                        </div>
                        <div class="text-danger" *ngIf="form.controls['companyEmail'].hasError('pattern') && showError">
                          *Please enter valid email.
                        </div> 
                    </div>
                </div>
                <div class="col-md-6 col-sm-12 col-lg-6">
                    <div class="form-group">
                        <label> Phone</label>
                        <div class="countryCode">
                            <span><input type="text" class="form-control" formControlName="countryCode" readonly placeholder="(+1)"/></span>
                            <input type="text" class="form-control" placeholder="Enter " formControlName="phoneNumber"  id="phone-number"  (keypress)="preventNumbers($event)"  maxlength="10">
                        </div>
                        <!-- appPhoneMask -->
                        <div class="text-danger" *ngIf="form.controls['phoneNumber'].hasError('required') && showError">
                            *Please enter phone number.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12 col-lg-6">
                    <div class="form-group">
                        <label> Linkedin Url</label>
                        <input type="text" class="form-control" placeholder="https://www.linkedin.com/company/deloitte" formControlName="linkedInLink">
                        <div class="text-danger" *ngIf="form.controls['linkedInLink'].hasError('required') && showError">
                            *Please enter Linkedin url.
                        </div>
                        <div class="text-danger" *ngIf="form.controls['linkedInLink'].hasError('pattern') && showError">
                            *Please enter Valid URL with https eg.(https://www.linkedin.com).
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12 col-lg-6">
                    <div class="form-group">
                        <label>Website</label>
                        <input type="text" class="form-control"  placeholder="https://www2.deloitte.com/us/en.html" formControlName="websiteLink">
                        <div class="text-danger" *ngIf="form.controls['websiteLink'].hasError('required') && showError">
                            *Please enter Website url.
                        </div>
                        <div class="text-danger" *ngIf="form.controls['websiteLink'].hasError('pattern') && showError">
                            *Please enter Valid URL with https eg.(https://www.deloitte.com).
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12 col-lg-12">
                  <div class="form-group">
                      <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="customCheckBox1" formControlName="subscribeHonorvet" [checked]="form.value.subscribeHonorvet ==1" (change)="form.value.subscribeHonorvet ==1">
                          <label class="custom-control-label" for="customCheckBox1">Subscribe me to the HonorVet</label>
                      </div>
                      <div class="text-danger" *ngIf="form.controls['subscribeHonorvet'].hasError('required') && showError">
                          *Please Subscribe me to the HonorVet.
                      </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                    <div class="form-group">
                        <!-- <a href="email-verification.html" class="commonBtn mt-5"> Save & Continue </a> -->
                        <input type="submit" class="commonBtn mt-5" value="Save &amp; Continue">
                    </div>
                </div>
            </div>
        </div>
      </form>
    </div>
  </section>
  
  <!-- End -->
  
  
  <ng-template #addMore>
    <div class="modal-body text-center">
      <form>
       <h3 class="pageTitle ">Allow us to access your location.</h3>
       <p >We need your location to provide you with the best experience Your location is safe with us.</p>
  
        <div class="form-group  mt-4">
            <ul class="list text-center">   
                <a class="addMoreBtn greyBtn" href="javascript:void(0);" (click)="closeModal()">Cancel</a>                                
                <a class="orangeBtn" href="javascript:void(0);" (click)="getLocation()">Allow location</a>
                                    
             </ul>
        </div>
    </form>
    </div>
  </ng-template>
  
  <!-- email verification -->
  <section class="pd-tb" *ngIf="showEmail">
    <div class="container email-verify ">
  
     <div class="linksent">
  
       <img src= "assets/images/email-verification.svg">
        <h3 class="heading2 mb-2">Thank you for choosing <span class="orangeText"> HonorVet</span></h3>
        <p class="para3">Thank you for choosing Honorvet and providing your details. We are verifying your details to allow only verified recruiters in system and provide top-notch, authentic experience to job seekers.</p>
  
  
  
     </div>
  
  
    </div>
   </section> 
   <div class="modal cropperModal" role="dialog" *ngIf="show">
      <div class="modal-dialog  cropperBox" role="document">
          <div class="modal-content">
              <div class="modal-header border-bottom-0 ">
                  <div class="form-title">
                      <h2 class="mainTitle text-center">Image Cropper</h2>
                  </div>
                  <!-- <button type="button cursorHandPoint" class="close " (click)="close()" data-dismiss="modal " aria-label="Close ">&times;</button> -->
              </div>
              <div class="modal-body">
                  <app-upload-file [objectProperty]="objectProp" (valueChange)='catchFile($event)'
                      (changeDetected)="onChangeDetected($event)"></app-upload-file>
                 
              </div>
          </div>
      </div>
  </div>